import React, { useEffect, useRef, useState } from "react";
import { getEnvUrl, getToken } from "../../../utils/Api";
import Loader from "../../common/loader";
import { toast } from "react-toastify";
import { checkPermissions } from "../../../Services/User/User";
import { deleteTvApkProjectByID } from "../../../Services/TvApksService/TvApkService";
import CreateEditProject from "./popups/createProject";
import ViewProject from "./popups/viewProject";
import { useNavigate } from "react-router-dom";

const $ = require("jquery");
require("datatables.net");

const Project = ({ data }) => {
    const tableRef = useRef(null);

    const [isLoading, setIsLoading] = useState(true);

    const [projectModal, setProjectModal] = useState(false);
    const [viewProjectModal, setViewProjectModal] = useState(false);
    const [editProjectModal, setEditProjectModal] = useState(false);

    const [projectId, setProjectId] = useState(null);

    const [rerender, setRerender] = useState(false);

    const navigate = useNavigate();

    const createPopupClose = (refresh = true) => {
        setProjectModal(false);

        if (refresh) {
            setRerender(!rerender);
        }
    };

    const editPopupClose = (refresh = true) => {
        setEditProjectModal(false);

        if (refresh) {
            setRerender(!rerender);
        }
    };

    const viewPopupClose = () => {
        setViewProjectModal(false);
    };

    useEffect(() => {
        if (
            !checkPermissions("subject_page") ||
            !checkPermissions("subject_page")
        ) {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        const table = $(tableRef.current).DataTable({
            processing: true,
            serverSide: true,
            serverMethod: "get",

            ajax: {
                url: `${getEnvUrl()}/admin/tvapk/getTvApkProjectsList`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                },
            },

            columns: [
                {
                    data: "id",
                },
                {
                    data: "name",
                },
                {
                    data: null,
                    title: "Actions",
                    render: () => {
                        return `
                <div>
                    <span class="a-open mx-2" title="Open Project">
                        <i class="bi bi-folder2-open"></i>
                    </span>

                    <span class="a-edit mx-2">
                        <i class="bi bi-pencil-square"></i>
                    </span>


                </div>
            `;
                    },
                },
            ],

            columnDefs: [
                {
                    targets: [2],
                    orderable: false,
                },
            ],

            createdRow: (row, data) => {
                if (!checkPermissions("subject_page")) {
                    $(row).find(".a-edit").remove();
                }

                if (!checkPermissions("subject_page")) {
                    $(row).find(".a-delete").remove();
                }

                $(row)
                    .find(".a-open")
                    .on("click", () => {
                        // Open TV APK list of this project
                        navigate(`/projects/${data.id}/tvapks`);
                    });

                $(row)
                    .find(".a-edit")
                    .on("click", () => {
                        setProjectId(data.id);
                        setEditProjectModal(true);
                    });

                $(row)
                    .find(".a-delete")
                    .on("click", () => {
                        if (window.confirm("Delete this project?")) {
                            deleteTvApkProjectByID(data.id)
                                .then((response) => {
                                    if (response.status) {
                                        toast.success(response.message);
                                        setRerender(!rerender);
                                    } else {
                                        toast.error(response.errorMessage);
                                    }
                                })
                                .catch(() => {
                                    toast.error("Unable to delete project");
                                });
                        }
                    });
            },

            drawCallback: () => {
                setIsLoading(false);
            },

            aaSorting: [[0, "desc"]],
        });

        return () => {
            table.destroy();
        };
    }, [rerender]);

    return (
        <div>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Projects</h1>
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">

                                {checkPermissions("subject_page") && (
                                    <h5 className="card-title">
                                        <button
                                            className="btn btn-primary float-right"
                                            onClick={() => setProjectModal(true)}
                                        >
                                            + Add Project
                                        </button>
                                    </h5>
                                )}

                                {isLoading && <Loader />}

                                <div className={isLoading ? "card-body hide" : "card-body"}>
                                    <table
                                        ref={tableRef}
                                        width="100%"
                                        className="table table-striped table-hover table-bordered"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Project ID</th>
                                                <th>Project Name</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {projectModal && (
                <CreateEditProject
                    isShow={projectModal}
                    close={createPopupClose}
                    type="CREATE"
                />
            )}

            {editProjectModal && (
                <CreateEditProject
                    isShow={editProjectModal}
                    close={editPopupClose}
                    projectId={projectId}
                    type="EDIT"
                />
            )}

            {viewProjectModal && (
                <ViewProject
                    isShow={viewProjectModal}
                    close={viewPopupClose}
                    projectId={projectId}
                />
            )}
        </div>
    );
};

export default Project;